import { gql } from 'graphql.macro';

export const assistantChatTemplate = gql`
    mutation assistantChat(
        $messages: [AssistantMessageInput!]!
        $currentLabId: String
        $streamId: String
        $currentPage: String
        $recentErrors: [AssistantRecentErrorInput!]
        $conversationId: String
    ) {
        assistantChat(
            messages: $messages
            currentLabId: $currentLabId
            streamId: $streamId
            currentPage: $currentPage
            recentErrors: $recentErrors
            conversationId: $conversationId
        ) {
            text
            articleLinks {
                articleId
                title
            }
            problemReportDraft
            conversationId
        }
    }
`;
